import { IAttachment } from "../../caseLawDocuments/model/Attachment";
import DeleteListResourceInteractor from "../../core/interactor/app/crud/DeleteListResourceInteractor";
import Constants from "../common/Constants";

export default class RemoveLegalViewAttachmentInteractor {
  private resource: DeleteListResourceInteractor<IAttachment>;

  constructor({ deleteListResource }: any) {
    this.resource = deleteListResource;
  }

  async execute(legalViewId: number, attachments: IAttachment[]) {
    return this.resource.execute(
      `${Constants.endpointBasePath}/${legalViewId}/${Constants.attachmentPath}`,
      attachments
    );
  }
}
